import React from 'react'

export default function Bouton(props) {
  let btnStyle =`border-0 ${props.btn}`
  return (
    <button disabled={props.disabled}  className={btnStyle} onClick={props.click} value={props.value}>{props.children} </button>
  )
}
